"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventBus_1 = require("./EventBus");
var install = function (Vue) {
    Vue.mixin({
        beforeCreate: function () {
            var options = this.$options;
            if (!(options.bus instanceof EventBus_1.default))
                return;
            /** Setting $bus on instance. */
            var bus = options.bus;
            Object.defineProperty(this, "$bus", {
                /** Getting bus dynamically. */
                get: function () {
                    return bus;
                },
            });
        },
    });
};
exports.default = install;
